export default __webpack_public_path__ + "f7c2997557c50191ac2be64bb045469b.png";